export default __webpack_public_path__ + "locales/tr/Common.json?hash=a1a73fd835a808ba45d39da38ff1fa66";